import {  Space, Typography } from 'antd'
import dayjs from 'dayjs'

// Function to format Institute data
export const formatInstitute = (instituteData, token) => {
    const { Text } = Typography
    const {
        _id: valueInstitute,
        name: labelInstitute,
    } = instituteData || {}
    return {
        label: labelInstitute && (
            <Space size={'large'}>
                {/* <div
                    style={{
                        width: '30px',
                        height: '30px',
                        padding: '8px 5px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `1px solid ${token.colorPalette.textColor.quinary}`,
                    }}
                >
                    {logoInstitute ? (
                        <Image src={logoInstitute} height={'30px'} width={'30px'} preview={false} />
                    ) : (
                        <div style={{ width: '30px', height: '30px' }}>
                            <InstituteDefaultIcon />
                        </div>
                    )}
                </div> */}
                <Text>{labelInstitute}</Text>
            </Space>
        ),
        value: valueInstitute,
    }
}

// Function to handle date transformation
export const formatDate = (value) => {
    if (value === null || value === undefined || value === '') return ''
    const parsed = dayjs(value)
    if (!parsed.isValid()) return ''
    return parsed.format('DD MMM YY')
}

/** Month + year label for education/experience ranges. Empty string if missing/invalid. */
export const formatMonthYear = (value) => {
    if (value === null || value === undefined || value === '') return ''
    const parsed = dayjs(value)
    if (!parsed.isValid()) return ''
    return parsed.toDate().toLocaleString('default', {
        year: 'numeric',
        month: 'long',
    })
}

// Function to format date picker
export const formatDatePicker = (value) => {
    if (value === null || value === undefined || value === '') return ''
    const parsed = dayjs(value)
    if (!parsed.isValid()) return ''
    return parsed.format('DD MMM YY')
}

export const camelCaseToWordConverter = (key) => {
    return key
        ?.replace(/([a-z])([A-Z])/g, '$1 $2')
        ?.replace(/^./, (str) => str.toUpperCase())
}

export const getInitials = (name = '') => {
    const parts = name.trim().split(' ')
    const first = parts[0]?.[0]?.toUpperCase() || ''
    const second = parts[1]?.[0]?.toUpperCase() || ''
    return `${first}${second}`
}

export const buildQueryParams = (obj) => {
    const params = []

    Object.entries(obj).forEach(([key, value]) => {
        if (key === 'experienceRange' && Array.isArray(value)) {
            if (value.length === 2) {
                const [from, to] = value
                if (from !== undefined && from !== null) {
                    params.push(
                        `totalExperienceFrom=${encodeURIComponent(from)}`
                    )
                }
                if (to !== undefined && to !== null) {
                    params.push(`totalExperienceTo=${encodeURIComponent(to)}`)
                }
            }
        } else if (Array.isArray(value)) {
            value.forEach((val) => {
                params.push(
                    `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                )
            })
        } else if (value !== undefined && value !== null && value !== '') {
            params.push(
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            )
        }
    })

    return params.join('&')
}

export const formatMilliseconds = (ms) => {
    if (ms < 1000) return `${ms} ms`

    const sec = ms / 1000
    if (sec < 60) return `${sec.toFixed(1)} sec`

    const min = sec / 60
    if (min < 60) return `${min.toFixed(1)} min`

    const hr = min / 60
    return `${hr.toFixed(1)} hr`
}

export function unique(array, propertyName) {
    return array.filter(
        (e, i) =>
            array.findIndex((a) => a[propertyName] === e[propertyName]) === i
    )
}

export const getColumnColor = (columnName) => {
    const name = columnName?.toLowerCase() || ''
    if (name.includes('to do')) return '#a78bfa'
    if (name.includes('progress')) return '#d0a254'
    if (name.includes('done')) return '#7bc88f'
    if (name.includes('block')) return '#e37b7b'

    const colors = [
        '#818cf8',
        '#34d399',
        '#f472b6',
        '#fbbf24',
        '#60a5fa',
        '#a78bfa',
        '#f87171',
        '#2dd4bf',
    ]
    let hash = 0
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }
    return colors[Math.abs(hash) % colors.length]
}
